import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
// Below is for import the icons
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import ScenarioQuestionformat from "../../Student/Reusablecomponents/ScenarioQuestionformat";
import { AssessmentName } from "../../Student/Reusablecomponents/RegularFunctions";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
// import {
//   Grade,
// } from "../../Student/Reusablecomponents/RegularFunctions";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import NSFLOgo from "../../Student/Assests/Images/NSFLOgo.jpg";
import NCLLOgo from "../../Student/Assests/Images/NCLogo.png";
import { FaAnglesLeft } from "react-icons/fa6";
const QuestionPaper = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const QuestionPaperRef = useRef();
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const [ViewSheet, SetViewSheet] = useState({});
    const [GetGrade, SetGetGrade] = useState(location.state.Grade.split(",")[0]);
    const [Load, SetLoad] = useState(false);

    // Fetches and displays question paper based on grade and schedule
    const GetQuestionSheet = async () => {
        SetLoad((prev) => !prev);
        await axios
            .get(
                process.env.REACT_APP_API_BASE_URL +
                `/NCLAdmin/GetAssessmentQuestionPaper?AssessmentScheduleId=${location.state?.AssessmentScheduleId}&Grade=${GetGrade}`,
                { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
            )
            .then((res) => {
                if (res.data[0].subjectName) {
                    const order = res.data.reduce((acc, item) => {
                        (acc[item.subjectName] = acc[item.subjectName] || []).push(item);
                        return acc;
                    }, {});
                    SetViewSheet(order);
                } else {
                    SetViewSheet({
                        Message: "Please generate questions for selected grade",
                    });
                }
                SetLoad((prev) => !prev);
            })
            .catch((err) => {
                SetViewSheet({
                    Message: "Please generate questions for selected grade",
                });
            });
    };
    useEffect(() => {
        GetQuestionSheet();
    }, [GetGrade])

    // Navigates back to previous page
    const CancelAssessments = () => {
        navigate(-1);
    };

    // Downloads printable PDF version of the question paper
    const DownloadPDF = () => {
        const printContents = QuestionPaperRef.current.innerHTML;
        const printWindow = window.open("", "", "height=800,width=600");
        const filename = `${location.state?.InstituteCode}_${location?.state?.AType}_QuestionPaper_Grade${GetGrade}`;
        printWindow.document.write(`
    <html>
      <head>
        <style>
          /* General styles for print */
          @media print {
            body {
            font-size: 25px;
              position: relative;
              
            }

            /* Watermark style */
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 100px;
              color: rgba(0, 0, 0, 0.06); /* low opacity z-index: 9999;*/
              pointer-events: none;          
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: space-between; /* logos left/right */
  align-items: center;
  white-space: nowrap;
  gap: 50px;
}

.Icons-Div div {
  flex: 1; /* take remaining space */
  text-align: center; /* center text */
}
.Icons-Div img {
              width: 30%;
              // height: 60px;
            }
            .Options  {
              display: flex !important; 
              align-items: center;
              gap: 8px;
              line-height: 1.4;
              page-break-inside: avoid;
              margin: 4px 0;
            }
.Each-Question{
 margin-bottom: 40px;
}
            .Options > span  {
              display: inline-flex !important;
              align-items: center;
              white-space: nowrap !important;
            }
.alignitems{
  display: inline-flex !important;
              align-items: center;
              white-space: nowrap !important;
}
      .PDFhide{
      display:none;}
      .Question div p{
      margin: 0mm !important;;
      }
       /*  .Question div{
    display: flex !important;
        white-space: nowrap !important;}*/
            /* Ensure watermark appears on every page */
            @page {
              size: auto;
              margin: 20mm;
            }
          }
        </style>
      </head>
      <body>
      <div class="Icons-Div">
       <img src="${NSFLOgo}" alt="NSF Logo"/>
       <div>
       <div><b>Assessment Date:</b> ${location.state?.date}</div>
       <div><b>Grade:</b> ${GetGrade}</div>
       </div>
       <img src="${NCLLOgo}" alt="NCL Logo" />
      </div>
        <div class="watermark">NORTH SOUTH FOUNDATION</div>
      ${printContents}
      <script>
          window.onload = function() {
            setTimeout(() => {
                 document.title = "${filename}";
              window.print();
              window.close();
            }, 400);
          }
        <\/script>
      </body>
    </html>
  `);
        printWindow.document.close();
    };

    // Converts grade string to grade dropdown options
    const Gradeoptions = location.state.Grade.split(",").map((item) => ({ display: `Grade ${item}`, value: item }))
    return (
        <>
            <div className="TeacherBgImage ">
                <InternetChecking />
                <div
                    className=" Buttons BackNavigation mb-3 "
                    style={{ float: "left" }}
                    onClick={CancelAssessments}
                >
                    <FaAnglesLeft /> Back{" "}
                </div>
                <div className="MainHeading">
                    {location.state?.InstituteCode} - {location.state?.AType} - Question Paper
                </div>

                <div className="dflex JSBetween mt-1">
                    <div></div>
                    <div className="dflex gap-3">

                        <DropdownValues className="NCLDropdown" options={Gradeoptions} selectoption={GetGrade}
                            onChange={(e) => SetGetGrade(e.target.value)} />
                        <button className="Buttons" onClick={DownloadPDF}>
                            Download Question Paper
                        </button>
                    </div>
                </div>

                <div className="Deatils-VASheet mt-2" ref={QuestionPaperRef}>
                    {Object?.keys(ViewSheet)?.length > 1 ? (
                        Object.keys(ViewSheet)?.map((order) => (
                            <div key={order} className="QuestionSet">
                                <div className="dflex JSBetween mt-4">
                                    <h5>
                                        <b>Subject :</b> {order}
                                    </h5>
                                    <h6>
                                        <b>No.of Questions :</b> {ViewSheet[order][0].noOfQuestions}
                                    </h6>
                                    <h6>
                                        <b>Total Credits :</b> {ViewSheet[order][0].totalCredits}
                                    </h6>
                                </div>
                                {ViewSheet[order]?.map((item, index) => (
                                    <div className="Each-Question dflex flexd-column">
                                        {item.scenario && (
                                            <div
                                                className="VScenario dflex flexd-column"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                }}
                                            >
                                                <div>
                                                    {" "}
                                                    <b>Scenario :</b>{" "}
                                                    <ScenarioQuestionformat scenario={item.scenario} />
                                                </div>
                                                <div>
                                                    {" "}
                                                    <b>Scenario Source :</b> {item.sSource} -{" "}
                                                    {item.sBookSource}{" "}
                                                    {item.sComments && (
                                                        <>
                                                            <b>Comments:</b> {item.sComments}
                                                        </>
                                                    )}{" "}
                                                </div>
                                            </div>
                                        )}

                                        <div className="RQuestion dflex">
                                            <div className="Question dflex flexd-column ">
                                                <div>
                                                    <b>Question {index + 1} :</b>
                                                    <ScenarioQuestionformat scenario={item.questions} />
                                                </div>
                                                <div>
                                                    <b>Question Source :</b> {item.qSource} -{" "}
                                                    {item.qBookSource}
                                                </div>
                                            </div>
                                            {/* {location.state?.AType !== 3 && (
                                                <div className="PDFhide">
                                                    <b>School Level Rating :</b> {item.schoolLevelRating}{" "}
                                                    | <b>Overall Rating :</b>
                                                    {item.overall}
                                                </div>
                                            )} */}
                                        </div>
                                        {item.questionType === "M" &&
                                            ["A", "B", "C", "D"].map((option, i) => (
                                                <div
                                                    key={i}
                                                    className="Options"
                                                    style={{
                                                        color:
                                                            option === item.answer
                                                                ? "green"
                                                                : option === item.userAnswer
                                                                    ? "red"
                                                                    : "black",
                                                    }}
                                                >
                                                    {option})
                                                    <span>
                                                        <ScenarioQuestionformat
                                                            scenario={item[`option${option}`]}
                                                        />
                                                        {option === item.answer ? (
                                                            <TiTick fontSize={25} />
                                                        ) : option === item.userAnswer ? (
                                                            <ImCross />
                                                        ) : (
                                                            ""
                                                        )}
                                                    </span>
                                                </div>
                                            ))}

                                        <div className="alignitems">
                                            {" "}
                                            <b>Answer :</b>
                                            <div>
                                                {" "}
                                                <ScenarioQuestionformat scenario={item?.answer} />{" "}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))
                    ) : (
                        <div
                            className="dflex JCCenter"
                            style={{ fontSize: "20px", margin: "2rem 0rem" }}
                        >
                            {" "}
                            {ViewSheet?.Message}
                        </div>
                    )}
                </div>
            </div>

            {Load && <Loading />}
        </>
    );
};
export default QuestionPaper;